import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

const BackgroundWrapper = styled.div`
  .flex-box {
    @media screen and (min-width: 768px) {
      gap: 40px;
    }
  }
`

const AccordionWrapper = styled.div`
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -0.5px;
    width: 100%;
    height: 8px;
    border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -0.5px;
    width: 100%;
    height: 8px;
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`

const AccordionItem = styled.details`
  width: 100%;

  &::marker {
    display: none;
  }
  &:not(:first-of-type) {
    border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }

  &:not([open]) {
    summary {
      padding: 16px;

      @media screen and (min-width: 768px) {
        padding: 24px;
      }
      @media screen and (min-width: 1024px) {
        padding: 32px 24px;
      }
    }
  }

  summary {
    list-style: none;
    cursor: pointer;
    padding: 16px 16px 0px 16px;

    @media screen and (min-width: 768px) {
      padding: 24px 24px 0 24px;
    }

    @media screen and (min-width: 1024px) {
      padding: 32px 24px 0px 24px;
    }

    &::-webkit-details-marker {
      display: none;
    }

    .flex {
      gap: 16px;

      @media screen and (min-width: 768px) {
        gap: 24px;
      }
    }
  }
  .accordion {
    &__content {
      margin-top: 32px;
      padding: 0px 16px 16px 16px;

      @media screen and (min-width: 768px) {
        padding: 0px 24px 24px 24px;
      }

      @media screen and (min-width: 1024px) {
        padding: 0px 24px 32px 24px;
      }

      @media screen and (min-width: 768px) {
        margin-top: 40px;
      }
      @media screen and (min-width: 1024px) {
        margin-top: 16px;
      }

      a {
        text-decoration: underline;
      }
    }
  }
`

const AccordionControl = styled.div`
  min-width: 24px;
  width: 24px;
  min-height: 24px;
  height: 24px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.opened {
    background: ${theme.wild.color.nova.base.solid[40]};
  }
  &.closed {
    background: ${theme.wild.color.nova.base.solid[20]};
  }
`

export { BackgroundWrapper, AccordionWrapper, AccordionItem, AccordionControl }